"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = require("react");
var snowplow_js_common_1 = require("@angi/snowplow-js-common");
var browser_tracker_1 = require("@snowplow/browser-tracker");
var SnowplowProvider_1 = require("../SnowplowProvider");
/**
 * Used to set enablePageView and dependencies to default values if none are passed in
 */
var defaultParams = {
  enablePageView: true,
  dependencies: []
};
/**
 * React app page view event. Uses a React useEffect hook with passed in dependencies to
 * manage the amount of page view calls
 *
 * @param params - object of possible values to pass to this method. Page view is required
 */
var useEnhancedPageView = function useEnhancedPageView(params) {
  var _Object$assign = Object.assign(Object.assign({}, defaultParams), params),
    enablePageView = _Object$assign.enablePageView,
    dependencies = _Object$assign.dependencies,
    pageName = _Object$assign.pageName,
    pageViewContexts = _Object$assign.pageViewContexts;
  var isSnowplowReady = (0, SnowplowProvider_1.useIsSnowplowReady)();
  (0, react_1.useEffect)(function () {
    if (enablePageView && isSnowplowReady) {
      var pageContext = (0, snowplow_js_common_1.pageAttributesContext)(pageName);
      (0, browser_tracker_1.addGlobalContexts)([pageContext]);
      (0, snowplow_js_common_1.enhancedPageView)(pageViewContexts);
      return function () {
        (0, browser_tracker_1.removeGlobalContexts)([pageContext]);
      };
    }
  }, [].concat(_toConsumableArray(dependencies), [isSnowplowReady]));
};
exports["default"] = useEnhancedPageView;